import React from 'react'
import Header from './header'
import './layout.css'

const Layout = (props) => {
  return (
    <>
      <div className='shutter'></div>
      <div id='container'>
        <Header alwaysUseAccentColorForNav={props.useAccentColorForNav}/>
        <main>{props.children}</main>
        <footer>
          <div id='copyRight'>
            Copyright © 2008 ManSysCo Pty Ltd. All rights reserved.
          </div>
          <div id='lastUpdated'>
            Last update: Nov /2020
          </div>
        </footer>
      </div>
    </>
  )
}

export default Layout;
